export default __webpack_public_path__ + "static/media/537.b3bc5618.gif";